export default __webpack_public_path__ + "73f3f6666f608fd315f51b7f662ebe33.mp3";